/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLocalCashDetail} from '../api'

 export const useQueryGetLocalCashDetail = createReactQueryHook('getLocalCashDetail', getLocalCashDetail)
